import React from 'react';
import { cn } from '../../../utils/cn';

// Status variants based on your existing patterns
const statusVariants = {
  online: 'bg-device-online shadow-[0_0_4px_#34c759]',      // Your .status-dot.online
  offline: 'bg-device-offline shadow-[0_0_4px_#ff3b30]',    // Your .status-dot.offline  
  connecting: 'bg-device-connecting shadow-[0_0_4px_#ffcc00] animate-pulse',
  unknown: 'bg-device-unknown'
};

const statusSizes = {
  sm: 'w-2 h-2',      // 8px - Your header status dots
  base: 'w-2.5 h-2.5', // 10px - Your main status dots
  lg: 'w-3 h-3'       // 12px - Larger status indicators
};

const StatusDot = ({
  status = 'unknown',
  size = 'base',
  className,
  'aria-label': ariaLabel,
  ...props
}) => {
  const baseStyles = 'rounded-full flex-shrink-0';
  const variantStyles = statusVariants[status] || statusVariants.unknown;
  const sizeStyles = statusSizes[size] || statusSizes.base;
  
  return (
    <span
      className={cn(baseStyles, variantStyles, sizeStyles, className)}
      aria-label={ariaLabel || `Status: ${status}`}
      role="status"
      {...props}
    />
  );
};

export default StatusDot;